const {h, render, Component} = require('preact')
const EmailIdInputView      = require('../../views/guest/email_id_input')
const OrderIdInputView      = require('../../views/guest/order_id_input')
const ValidateUtil = require('../../../../../groupon/frontend/validate');

class GuestHelp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initial: true,
      emailId: "",
      orderId: "",
      validEmailId: true,
      validOrderId: true
    }
    this.handleClick = this.handleClick.bind(this);
    this.validateInputFields = this.validateInputFields.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({initial: false})
    let enableContinue = this.validateInputFields()
    if(enableContinue) {
      this.props.onGuestHelp({ orderId: document.getElementById('order-id-input').value.trim(), 
        emailId: document.getElementById('email-id-input').value.trim()})
    }
   }

  validateInputFields() {
    let orderId = this.state.orderId;
    let emailId = this.state.emailId;
    let isValidCartId = this.isInputValid(orderId) && ValidateUtil.cartId(orderId)
    let isValidEmailId = this.isInputValid(emailId) && ValidateUtil.email(emailId)
    this.setState({validOrderId: isValidCartId, validEmailId:isValidEmailId})
    return isValidEmailId && isValidCartId;
  }

  isInputValid(value) {
    return (value.length > 0)
  }

  handleInputChange(inputType, e) {
    if(inputType == 'emailId')
      this.setState({emailId: e.target.value}, () => {
        if(!this.state.initial) { this.validateInputFields() }
      })  
    else
      this.setState({orderId: e.target.value}, () => {
        if(!this.state.initial) { this.validateInputFields() }
      })  
  }

  render() {
    return (
      <section class="main row cs_support_header" id="guest-help-input-form">
        <h2 class="guest-help-header">{I18n.translate("js.modules.web_2018.guest_help_header")}</h2>
        <div class="guest-help-intro">{I18n.translate("js.modules.web_2018.guest_help_intro")}</div>
        <form class="user-input-form" onsubmit={this.handleClick}>
          <OrderIdInputView handleInputChange={this.handleInputChange} orderId={this.state.orderId} isValid={this.state.validOrderId}/>
          <EmailIdInputView handleInputChange={this.handleInputChange} emailId={this.state.emailId} isValid={this.state.validEmailId}/>
          <input type="submit" class="btn continue-button" data-bhw="guest_checkout_continue_button" value={I18n.translate("js.modules.web_2018.continue")}/>
        </form>
      </section>
    )
  }

}

module.exports = GuestHelp
